import React, { useContext, useEffect } from "react";
import { amplitudeCategories } from "@collectivehealth/frontend-analytics";
// DLS
import "@collectivehealth/dls-link";
import "@collectivehealth/dls-panel";

// Components
import Card from "components/Card/Card.js";
import PageBody from "components/templates/PageBody";
import DataSection from "./DataSection.js";
import MenuBar from "components/templates/MenuBar";
import { ReactComponent as UnderstandingYourDataSvg } from "./understandingYourData.svg";

// Constants
import { ROUTE_PARAMS } from "constants/routing";

// Contexts
import PageTitleContext from "contexts/PageTitle";

// Hooks
import usePageEnteredLogger from "hooks/usePageEnteredLogger";

// Styles
import styles from "./AboutPage.css";

const CARDS = [
  {
    color: "red",
    title: "Helpful terms",
    content: "Your source for common terms and their definitions",
    href: "terms",
    eventName: "helpfulTermsEntered"
  },
  {
    color: "blue",
    title: "Filters",
    content: "Tell your data's story with flexible filters",
    href: "filters",
    eventName: "dataFiltersEntered"
  },
  {
    color: "green",
    title: "Data Calculations",
    content: "Get the details on how we determine calculations and logic",
    href: "calculations",
    eventName: "howWeCalculateEntered"
  }
];

function AboutPage() {
  // Log pageEntered event
  usePageEnteredLogger(amplitudeCategories.CLAIMS, ROUTE_PARAMS.SERVICE);

  // Set page title
  const [, setPageTitle] = useContext(PageTitleContext);
  useEffect(() => {
    setPageTitle("Understanding your data");
  }, [setPageTitle]);

  return (
    <PageBody
      menu={<MenuBar />}
      main={
        <dls-panel class={styles.root}>
          <div className={styles.titlePanel} slot="panel-head">
            <div>
              <h1 className={styles.header}>How to understand your company's data</h1>
              <p className={styles.bodyText}>
                Find tips and definitions on how to read your company’s data.
              </p>
            </div>
            <UnderstandingYourDataSvg className={styles.svg} />
          </div>
          <div slot="panel-body">
            <div className={styles.cardsWrapper}>
              {CARDS.map(card => (
                <Card
                  key={card.href}
                  color={card.color}
                  title={card.title}
                  content={card.content}
                  href={card.href}
                  optionalClasses={styles.card}
                  clickEventName={card.eventName}
                />
              ))}
            </div>
            <DataSection />

            <div className={styles.chartCopyright}>
              Visualizations powered by{" "}
              <dls-link label="Chartjs" href="https://www.chartjs.org/" target="_blank"></dls-link>{" "}
              &copy;, available under the{" "}
              <dls-link
                label="MIT license"
                href="https://opensource.org/licenses/MIT"
                target="_blank"
              ></dls-link>
              .
            </div>
          </div>
        </dls-panel>
      }
    />
  );
}

export default AboutPage;
